import axios from "axios"
import rotuer from "@/router/router.js"

//window.baseURL = "http://localhost:5005/"
//window.baseURL = "http://45.77.45.31:7035/"
window.baseURL = "https://v-glory.com/api/"
axios.defaults.baseURL = window.baseURL

axios.interceptors.request.use(config => {
    config.headers = {
        Authorization: localStorage.getItem("JWT")
    }
    return config   
})

axios.interceptors.response.use(res => {
    if (res.data.data) {
        if (String(res.data.data.msg).includes('token')) {
            rotuer.replace("/login")
        } 
    }
    

    if (res.data.data) {
        let a = []
        if (res.data.data instanceof Array) {
            res.data.data.forEach(item => {
                initDate(item, 'create_time','createAt')//將create_time  變成createAt

                if (res.config.url.includes("order")) {
                    initDate(item, 'delivery_time','deliveryAt')//將create_time  變成createAt
                    initDate(item, 'pay_time','payAt')//將create_time  變成createAt
                }
            })
        }
        if (res.config.url.includes("admin/user")) {
            if (res.data.data.user_list instanceof Array) {
                res.data.data.user_list.forEach(item => {
                    initDate(item, 'create_time','createAt')
                })
            }
        }
        if (res.config.url.includes("admin/customer")) {
            if (res.data.data instanceof Array) {
                res.data.data.forEach(item => {
                    initDate(item, 'create_at','createAt')
                })
            }
        }
        
    }
    return res
})

// 將所有時間變成  yyyy-MM-dd 格式
function initDate (item,key,key1) {
    if (item instanceof Object) {
        if (item[key]) {
            let D = new Date(item[key])
            let y = D.getFullYear()
            let M = D.getMonth() + 1
            M = M < 10 ? "0" + M : M
            let d = D.getDate()
            d = d < 10 ? "0" + d : d
            item[key1] = y + '-' + M + '-' + d
        } else {
            item[key1] = "暫無時間"
        }
    }
    
        
}

export default axios